var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-lg"},[_vm._v(" Selecione um tipo de cadastro no menu lateral para gerenciá-lo. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }